<template>
  <div class="dqyxfx-warp">
    <resize-container :tabShow="tabShow">
      <div class="left-content" v-show="tabShow" slot="left">
        <tab-tree :data="viewTreeData" @tabTreeDefault="tabTreeDefault" @tabTreeClick="tabTreeClick" @changeCompany="changeCompany"></tab-tree>
      </div>
      <div class="right-content">
        <div class="search-box box">
          <time-search ref="timeSearch" :control="{data:timeData}" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick" :pickerOptions="pickerOptions" :pickerOptionsWeek="pickerOptionsWeek" :pickerOptionsMonth="pickerOptionsMonth" :pickerOptionsYear="pickerOptionsYear"></time-search>
        </div>
        <div class="tab-pane">
          <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
          <nk-chart-pre :data="chartData" :timeTitle="timeTitle" :title="chartstitle" class="box-magin" :unit="'kW'" :showMax="true"></nk-chart-pre>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import TabTree from "@/components/common/TabTree.vue";
import TimeSearch from "@/components/common/TimeSearch.vue";
import BtnShow from "@/components/common/BtnShow.vue";
import NkChartPre from "@/components/page/predict/NkChartPre.vue";
import api from "@common/api/index.js";
import { findDataByParam } from "@/utils/index.js";
import handleData from "@/utils/handleData.js";
import ResizeContainer from "@/components/common/resizeContainer.vue";
import { isNull, isUndefined } from "util";

let eleTimeData = [
  {
    type: "day",
    label: "日",
  },
  {
    type: "week",
    label: "周",
  },
  {
    type: "month",
    label: "月",
  },
];
export default {
  components: {
    TabTree,
    TimeSearch,
    BtnShow,
    NkChartPre,
    ResizeContainer
  },
  data () {
    return {
      timeData: eleTimeData,
      tabData: [],
      searchType: "hour",
      tabShow: true,
      viewTreeData: [],
      selectedTab: "",
      selectedMeasure: {
        measureId: "",
        measureName: "",
      },
      selectedDate: {
        startTime: "",
        endTime: "",
      },
      //传入的计量点id
      queryId: "",
      viewId: "",
      treeTabObj: null,
      leftTreeStaticData: [],
      leftTreeData: [],
      defaultCheckedKeys: [],
      currentNodekey: "",
      timeType: [{ value: "0", label: "日" }],
      toTime: "toTime",
      alarnclass: "alarnclass",
      elem: {},
      chartData: [
        {
          data: [],
          xData: [],
          tip: ["预测需量", "实际需量"],
          title: "需预测曲线图",
          ifBgColor: true,
        },
      ],
      unit: "",
      timeTitle: "",
      chartstitle: "",
      typeIndex: 0,
      measureId: [],
      pickerOptions: {
        // 当我们选择日期时的回调方法。返回两个日期的最大值和最小值，第一次返回一个值，第二次返回两个值
        onPick: ({ maxDate, minDate }) => {
          //当我们选择两个值的时候，就认为用户已经选择完毕
          if (maxDate != null && minDate != null) {
            this.maxDate = maxDate;
            this.minDate = minDate;
          }
        },
        disabledDate: (time) => {
          let maxDate = this.maxDate;
          let minDate = this.minDate;
          if (maxDate != null && minDate != null) {
            let days = maxDate.getTime() - minDate.getTime(); //计算完之后必须清除，否则选择器一直处于禁止选择的状态
            this.maxDate = null;
            this.minDate = null;
            return parseInt(days / (1000 * 60 * 60 * 24)) > 30;
          } else {
            //设置当前时间后的时间不可选
            return (
              time.getTime() >
              new Date(new Date().setDate(new Date().getDate() + 1))
            );
          }
        },
      },
      pickerOptionsWeek: {
        // 当我们选择日期时的回调方法。返回两个日期的最大值和最小值，第一次返回一个值，第二次返回两个值
        onPick: ({ maxDate, minDate }) => {
          //当我们选择两个值的时候，就认为用户已经选择完毕
          if (maxDate != null && minDate != null) {
            this.maxDate = maxDate;
            this.minDate = minDate;
          }
        },
        disabledDate: (time) => {
          let maxDate = this.maxDate;
          let minDate = this.minDate;
          if (maxDate != null && minDate != null) {
            let days = maxDate.getTime() - minDate.getTime(); //计算完之后必须清除，否则选择器一直处于禁止选择的状态
            this.maxDate = null;
            this.minDate = null;
            return parseInt(days / (1000 * 60 * 60 * 24)) > 30;
          } else {
            //设置当前时间后的时间不可选
            return (
              time.getTime() >
              new Date(new Date().setDate(new Date().getDate() + 7))
            );
          }
        },
      },
      pickerOptionsMonth: {
        // 当我们选择日期时的回调方法。返回两个日期的最大值和最小值，第一次返回一个值，第二次返回两个值
        onPick: ({ maxDate, minDate }) => {
          //当我们选择两个值的时候，就认为用户已经选择完毕
          if (maxDate != null && minDate != null) {
            this.maxDate = maxDate;
            this.minDate = minDate;
          }
        },
        disabledDate: (time) => {
          let maxDate = this.maxDate;
          let minDate = this.minDate;
          if (maxDate != null && minDate != null) {
            let days = maxDate.getTime() - minDate.getTime(); //计算完之后必须清除，否则选择器一直处于禁止选择的状态
            this.maxDate = null;
            this.minDate = null;
            return parseInt(days / (1000 * 60 * 60 * 24)) > 30;
          } else {
            let nextDay = new Date(new Date().setDate(new Date().getDate() + 1));
            if (nextDay.getMonth() != new Date().getMonth()) {
              //设置当前时间后的时间不可选
              return (
                time.getTime() >
                new Date(new Date().setMonth(new Date().getMonth() + 1))
              );
            } else {
              return time.getTime() > new Date();
            }
          }
        },
      },
      pickerOptionsYear: {
        // 当我们选择日期时的回调方法。返回两个日期的最大值和最小值，第一次返回一个值，第二次返回两个值
        onPick: ({ maxDate, minDate }) => {
          //当我们选择两个值的时候，就认为用户已经选择完毕
          if (maxDate != null && minDate != null) {
            this.maxDate = maxDate;
            this.minDate = minDate;
          }
        },
        disabledDate: (time) => {
          let maxDate = this.maxDate;
          let minDate = this.minDate;
          if (maxDate != null && minDate != null) {
            let days = maxDate.getTime() - minDate.getTime(); //计算完之后必须清除，否则选择器一直处于禁止选择的状态
            this.maxDate = null;
            this.minDate = null;
            return parseInt(days / (1000 * 60 * 60 * 24)) > 30;
          } else {
            //设置当前时间后的时间不可选
            return (
              time.getTime() >
              new Date(new Date().setFullYear(new Date().getFullYear() + 1))
            );
          }
        },
      },
    };
  },
  created () {
    if (!this.$route.query.id) {
      this.init();
    }
  },
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted () {
  },
  activated () { },
  methods: {
    changeCompany (companyId) {
      let vm = this;
      api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(
        companyId,
        "/predict/demandPredict",
        null
      )
        .then((res) => {
          const viewTreeData = findDataByParam("viewTree", true, res.data);
          vm.viewTreeData = viewTreeData;
        });
    },
    timeControlChange (e) {
      this.selectedDate = e;
    },
    TimeControlClick (e) {
      let vm = this;
      vm.selectedDate = e;
      vm.getData();
    },
    tabTreeDefault (e) {
      let vm = this;
      this.selectedMeasure = e;
      vm.getData();
    },
    tabTreeClick (e) {
      let vm = this;
      this.selectedMeasure = e;
      vm.getData();
    },
    //查询事件
    getData () {
      let vm = this;
      let chartData = JSON.parse(JSON.stringify(vm.chartData));
      chartData[0].xData = [];
      chartData[0].data[0] = [];
      chartData[0].data[1] = [];
      vm.$api.predict
        .puzzlePredictQuantityRequiredByHour(
          [
            {
              measureId: vm.selectedMeasure.measureId,
              pointNumber: "0",
              pointCode: "228"
            },
          ],
          vm.selectedDate.startTime,
          vm.selectedDate.endTime,
          vm.selectedDate.dateType
        )
        .then((res) => {
          //实际用电
          res.data[0].realData.forEach((item) => {
            chartData[0].data[1].push(
              item.value != "-" ? item.value.toFixed(2) : item.value
            );
          });
          //预测用电
          res.data[0].predictedData.forEach((item) => {
            chartData[0].data[0].push(
              item.value != "-" ? item.value.toFixed(2) : item.value
            );
            chartData[0].xData.push(item.time);
          });
          vm.chartData = chartData;
        });
    },
  },
};
</script>
<style  scoped>
.ulbox {
  display: flex;
  flex-wrap: wrap;
}
.ulbox > li {
  line-height: 30px;
  font-size: 18px;
  list-style: none;
  width: 50%;
}

.dqyxfx-warp {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  overflow: hidden;
}
.left-content {
  height: 100%;
  width: 100%;
}
.right-content {
  flex: 1;
  position: relative;
  display: flex;
  flex-flow: column;
  height: 100%;
}
.search-box {
  height: 36px;
  line-height: 36px;
}
.tab-pane {
  display: flex;
  flex: 1;
  background: #ffffff;
  margin-top: 14px;
  border-radius: 4px;
  overflow: hidden;
}
.check-box {
  position: absolute;
  top: 0px;
  right: 54px;
  width: 180px;
  height: 150px;
  z-index: 999;
  overflow: auto;
  box-shadow: 0px 0px 5px #bcbcbc;
}
.check-btn-img {
  position: absolute;
  right: 0px;
  top: 0px;
  padding: 6px;
  z-index: 999;
  border-radius: 4px;
  box-shadow: 0px 0px 5px #bcbcbc;
}
.check-btn {
  position: absolute;
  right: 10px;
  top: 4px;
  z-index: 999;
  cursor: pointer;
}
.check-box ul {
  width: 100%;
  list-style: none;

  margin: 0px;
  padding: 0px;
}
.check-box ul li {
  padding: 4px;
}

.top {
  line-height: 40px;
  background: #fff;
  border-radius: 4px;

  padding: 14px;
  box-sizing: content-box;
}

.bg-box {
  background: #fff;
  border-radius: 4px;
  padding: 14px;
  box-sizing: content-box;
  border: 1px solid #dedcdc;
}

.tab {
  border: 1px solid #dedcdc;
  border-radius: 4px;
}
.tab
  >>> .el-tabs--top.el-tabs--card
  > .el-tabs__header
  .el-tabs__item:nth-child(2) {
  padding: 0px;
}
.tab >>> .el-tabs__nav-scroll {
  border-radius: 4px;
  background: #dbdbdb;
}
.tab >>> .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 0px;
}
.tab >>> .el-tabs--card > .el-tabs__header {
  border: 0px;
}
.tab >>> .el-tabs__item {
  height: 64px;
  line-height: 64px;
  width: 100px;
  text-align: center;
  padding: 0px;
  border: none !important;
  color: #000;
  font-weight: bold;
}
.tab >>> .el-tabs__item.is-active {
  /* background: #fff;
  border: 1px solid #fff; */

  color: #1d6ce9;
  border-bottom: 6px solid #1d6ce9 !important;
}
.tab >>> .el-tabs__header {
  margin: 0px;
}
.tab >>> .el-tabs__content {
  background: #fff;
  border-radius: 4px;
}
.tab >>> .ele-work-warp {
  margin-top: 14px;
}
</style>